import React from 'react'
import { Image } from 'react-bootstrap'

const RoadBikeImage = () => {
  return (
    <Image
      className='mt-3'
      src='/roadsizingannotated.png'
      alt='Road Bike Reference Image'
      style={{ maxWidth: '100%' }}
    />
  )
}

export default RoadBikeImage
